import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  MobileStepper,
  withStyles,
  Button as MUIButton,
} from '@material-ui/core';
import { Button } from 'components/Ui';
import SwipeableViews from 'react-swipeable-views';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { Default } from 'components/Media';
import { quizQuestions } from '../questions';
import Answer from './Answer';
import Question from './Question';
import styles from './styles.scss';
import jsStyles from './styles';

class Queue extends Component {
  constructor(props) {
    super(props);

    const { questionsQueue } = props;

    this.state = {
      activeStep: 0,
      isQuestionsAnswered: false,
      currentQuestionsType: questionsQueue[0],
      questions: quizQuestions[questionsQueue[0]],
      currentStepsCount: quizQuestions[questionsQueue[0]].length,
      currentAnswers: quizQuestions[questionsQueue[0]][0].answers,
      userAnswer: {},
    };
  }

  isFirstStep = () => {
    const {
      props: { questionsQueue },
      state: { currentQuestionsType, activeStep },
    } = this;

    const questionTypeIndex = questionsQueue.findIndex(
      (type) => type === currentQuestionsType,
    );

    return questionTypeIndex === 0 && activeStep === 0;
  };

  isLastStep = () => {
    const {
      props: { questionsQueue },
      state: { currentQuestionsType, activeStep, currentStepsCount },
    } = this;

    const questionTypeIndex = questionsQueue.findIndex(
      (type) => type === currentQuestionsType,
    );

    return (
      questionTypeIndex === questionsQueue.length - 1 &&
      activeStep === currentStepsCount - 1
    );
  };

  handleNext = () => {
    const {
      state: { currentQuestionsType, activeStep, currentStepsCount },
      props: { questionsQueue },
    } = this;

    const questionTypeIndex = questionsQueue.findIndex(
      (type) => type === currentQuestionsType,
    );
    const isLastQuestionAtSection =
      questionsQueue.length > questionTypeIndex &&
      activeStep === currentStepsCount - 1;

    if (isLastQuestionAtSection) {
      this.setState({
        activeStep: 0,
        currentQuestionsType: questionsQueue[questionTypeIndex + 1],
        questions: quizQuestions[questionsQueue[questionTypeIndex + 1]],
        isQuestionsAnswered: false,
        currentAnswers:
          quizQuestions[questionsQueue[questionTypeIndex + 1]][0].answers,
      });
    } else {
      this.setState((prevState) => ({
        activeStep: prevState.activeStep + 1,
        isQuestionsAnswered: false,
        currentAnswers:
          quizQuestions[questionsQueue[questionTypeIndex]][activeStep + 1]
            .answers,
      }));
    }
  };

  handleBack = () => {
    const {
      state: { currentQuestionsType, activeStep },
      props: { questionsQueue },
    } = this;

    const questionTypeIndex = questionsQueue.findIndex(
      (type) => type === currentQuestionsType,
    );
    const isFirstQuestionAtSection =
      questionTypeIndex !== 0 && activeStep === 0;

    if (isFirstQuestionAtSection) {
      this.setState({
        activeStep:
          quizQuestions[questionsQueue[questionTypeIndex - 1]].length - 1,
        currentQuestionsType: questionsQueue[questionTypeIndex - 1],
        questions: quizQuestions[questionsQueue[questionTypeIndex - 1]],
        currentAnswers:
          quizQuestions[questionsQueue[questionTypeIndex - 1]][0].answers,
      });
    } else {
      this.setState((prevState) => ({
        activeStep: prevState.activeStep - 1,
        currentAnswers:
          quizQuestions[questionsQueue[questionTypeIndex]][activeStep - 1]
            .answers,
      }));
    }
  };

  handleStepChange = (activeStep) => {
    this.setState({ activeStep });
  };

  onAnswer = (event) => {
    const { currentAnswers, isQuestionsAnswered, userAnswer } = this.state;

    this.setState({
      isQuestionsAnswered: !isQuestionsAnswered,
      userAnswer: event.currentTarget
        ? currentAnswers[event.currentTarget.name]
        : userAnswer,
    });
  };

  render() {
    const {
      props: { classes, theme, finishQuiz },
      state: {
        activeStep,
        isQuestionsAnswered,
        currentQuestionsType,
        currentStepsCount,
        userAnswer,
        questions,
      },
    } = this;

    return (
      <div className={styles.questionWrapper}>
        {!isQuestionsAnswered ? (
          <Fragment>
            <div className={styles.number}>Question {activeStep + 1}</div>
            <div className={styles.area}>{currentQuestionsType}</div>
            <div className={classes.root}>
              <SwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={activeStep}
                onChangeIndex={this.handleStepChange}
                enableMouseEvents
              >
                {questions.map((question) => (
                  <Question
                    text={question.text}
                    onClick={this.onAnswerClick}
                    key={question.text}
                  />
                ))}
              </SwipeableViews>
              <MobileStepper
                steps={currentStepsCount}
                position="static"
                variant="dots"
                activeStep={activeStep}
                classes={{
                  root: classes.mobileStepper,
                  dot: classes.dot,
                  dotActive: classes.dotActive,
                  dots: classes.dots,
                }}
                nextButton={
                  this.isLastStep() ? (
                    <MUIButton
                      size="small"
                      className={classes.buttons}
                      onClick={finishQuiz}
                      disableRipple
                    >
                      <Default>Finish</Default>
                      <KeyboardArrowRight className={styles.arrowBtn} />
                    </MUIButton>
                  ) : (
                    <MUIButton
                      size="small"
                      className={classes.buttons}
                      onClick={this.handleNext}
                      disableRipple
                    >
                      <Default>Next</Default>
                      <KeyboardArrowRight className={styles.arrowBtn} />
                    </MUIButton>
                  )
                }
                backButton={
                  <MUIButton
                    className={classes.buttons}
                    size="small"
                    onClick={this.handleBack}
                    disabled={this.isFirstStep()}
                    disableRipple
                  >
                    <KeyboardArrowLeft className={styles.arrowBtn} />
                    <Default>Back</Default>
                  </MUIButton>
                }
              />
            </div>
            <div className={styles.btns}>
              <Button
                text="Yes"
                name="YES"
                className={styles.btn}
                onClick={this.onAnswer}
              />
              <Button
                text="No"
                name="NO"
                className={styles.btn}
                onClick={this.onAnswer}
              />
            </div>
          </Fragment>
        ) : (
          <Answer
            answer={userAnswer}
            onBackClick={this.onAnswer}
            isStepLast={this.isLastStep()}
            finishQuiz={finishQuiz}
            onNextClick={this.handleNext}
          />
        )}
      </div>
    );
  }
}

Queue.propTypes = {
  questionsQueue: PropTypes.array,
  classes: PropTypes.object,
  theme: PropTypes.object,
  finishQuiz: PropTypes.func,
};

export default withStyles(jsStyles, { withTheme: true })(Queue);
